/**
 * Shared formatters for promo code display. Whop stores percentages as
 * fractions (0.2 = 20%) and flat amounts in major units of the promo's
 * currency, so the picker and the analytics card both need the same
 * normalization. Keep both reading from here so a Whop change only updates
 * one place.
 */
import { getCurrencySymbol } from './currency';

type PromoType = 'percentage' | 'flat_amount';
type PromoDuration = 'forever' | 'once' | 'repeating' | null | undefined;

export function formatPromoDiscount(
  amountOff: number,
  promoType: PromoType,
  currency: string
): string {
  if (promoType === 'percentage') {
    // Strip trailing zeros so "20%" displays cleanly while "6.9%" preserves
    // precision.
    const pct = parseFloat((amountOff * 100).toFixed(2));
    return `${pct}% off`;
  }
  return `${getCurrencySymbol(currency)}${amountOff.toFixed(2)} off`;
}

export function formatPromoDuration(
  duration: PromoDuration,
  durationMonths: number | null | undefined
): string {
  if (duration === 'forever') return 'forever';
  if (duration === 'once') return 'first charge only';
  if (duration === 'repeating' && durationMonths) {
    return `for ${durationMonths} mo`;
  }
  return '';
}
